import { FormControlLabel, Select, Switch } from "@mui/material";
import FormField from "components/FormField";
import SoftButton from "components/SoftButton";
import SoftSelect from "components/SoftMultiSelect";
import React, { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAgencyInfo } from "context/agency";
import {
  useSaasStripeProducts,
  useUpdateSaasConfiguration,
  useCategoryPricing,
  useCreateCategoryPricing,
} from "queries/saas";
import ReactSelect from "react-select";
import SoftTypography from "components/SoftTypography";

const ConfigrationForm = ({ editdata, onClose, handleRefresh, handleRefereshpricing }) => {
  const [step, setStep] = useState(1);
  const [selectedOption, setSelectedOption] = useState(null);
  const [agency] = useAgencyInfo();
  const queryClient = useQueryClient();
  const [loader, setLoader] = useState(false);
  const [aichanger, setaichanger] = useState(false);
  const [celenderchanger, setcelenderchanger] = useState(false);
  const [agents, setAgents] = useState([]);
  const [changedPlugins, setChangedPlugins] = useState([]);
  const [selectedStripeProducts, setSelectedStripeProducts] = useState([]);

  const [agentLimit, setAgentLimit] = useState(editdata?.agenct_config?.agent_limit || 0);
  const [toggleChecked, setToggleChecked] = useState(editdata?.agenct_config?.allow || false);
  // NOTE: LoadPromptwithid (same fetch_category_pricing call as onLoad below,
  // but assigning response.data instead of response.promptslabel) was dead
  // code - defined but never called anywhere in this file - so it was
  // dropped rather than migrated onto the now-removed promplabels state setter.

  const { data: stripeProductsResponse } = useSaasStripeProducts(agency._id);
  const stripeProducts = (stripeProductsResponse?.data || []).map((product) => ({
    label: product.name,
    value: product.id,
  }));

  useEffect(() => {
    // Set initial selected products if editing - mirrors the old
    // fetchStripeProducts() post-fetch derivation, now reactive to the query.
    // Depends on stripeProductsResponse (stable query data), not the
    // re-mapped stripeProducts array, which is a new reference every render.
    if (editdata?.selected_plan_for_product?.length > 0 && stripeProducts.length > 0) {
      const selected = stripeProducts.filter((product) =>
        editdata.selected_plan_for_product.includes(product.value)
      );
      setSelectedStripeProducts(selected);
    }
  }, [stripeProductsResponse, editdata]);

  useEffect(() => {
    // Set initial states based on editdata
    if (editdata?.apps) {
      setcelenderchanger(editdata?.apps?.[0]?.snapshotselected?.includes("AI Celender App") || editdata?.apps?.includes("AI Celender App"));
      setaichanger(editdata?.apps?.[0]?.snapshotselected?.includes("AI Social App") || editdata?.apps?.includes("AI Social App"));
    }
  }, [editdata]);
  const [isFreeSaas, setIsFreeSaas] = useState(editdata?.is_free_saas);
  const [formData, setFormData] = useState({
    _id: editdata._id,
    agency_id: agency._id,
    product_id: editdata?.product_id,
    plan: { planName: editdata?.plan?.planName, description: editdata?.plan?.description },
    isFreeSaas: editdata?.is_free_saas,
    vat: editdata?.vat || null,
    category: {
      categorySelected: editdata?.category?.categorySelected,
      categoryOptions: editdata?.category?.categoryOptions,
    },
    monthly_price: editdata?.monthly_amount / 100,
    yearly_price: editdata?.yearly_amount / 100,
    user_limit: parseInt(editdata?.user_limit ? editdata?.user_limit : 0),
    apps: {
      snapshotselected: editdata?.apps?.[0]?.snapshotselected || editdata?.apps || [],
    },
    trial_and_credit: {
      active_trile_period: editdata.trial_and_credit.days !== 0 ? true : false,
      add_credit: editdata.trial_and_credit.credit_amount !== 0 ? true : false,
      days: parseInt(editdata?.trial_and_credit?.days ? editdata?.trial_and_credit?.days : 0),
      credit_amount: parseInt(
        editdata?.trial_and_credit?.credit_amount ? editdata?.trial_and_credit?.credit_amount : 0
      ),
    },
    rebilling: {
      ai_active: editdata?.rebilling?.ai_active ? editdata?.rebilling?.ai_active : false,
      markupmargin: editdata?.rebilling?.markupmargin ? editdata?.rebilling?.markupmargin : 0,
    },
    celenderchanger: celenderchanger,
    agenct_config: editdata?.agenct_config || { plugins: [], agent_limit: 0, allow: false },

    additional_accounts: editdata?.additional_accounts || 0,
    daily_token_usage: editdata?.daily_token_usage || 0,
    additional_accounts_enabled: editdata?.additional_accounts_enabled || false,
    selected_agents: editdata?.selected_agents || [],
    promptlabel_ids: editdata?.promptlabel_ids || [],
    number_of_agents: editdata?.number_of_agents,
    create_agents: editdata?.create_agents,
    add_plan_to_product: editdata?.add_plan_to_product,
    selected_plan_for_product: editdata?.selected_plan_for_product || [],
  });

  console.log(editdata, "editdata");

  const [errors, setErrors] = useState({});
  const validateStep1 = () => {
    const step1Errors = {};
    if (!formData.plan.planName.trim()) {
      step1Errors.planName = "First Name is required";
    }
    if (!formData.plan.description.trim()) {
      step1Errors.description = "Description is required";
    }
    setErrors(step1Errors);
    return Object.keys(step1Errors).length === 0;
  };
  const handleNext = () => {
    if (step < 8) {
      setStep(step + 1);
    }
  };

  const handleCustomTab = () => {
    if (step > 1) {
      setStep(step - 1);
    }
  };

  const handlePrevious = () => {
    setStep(step - 1);
  };
  const { mutateAsync: updateSaasConfigration } = useUpdateSaasConfiguration();
  const handleFormSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    // Handle form submission logic here
    setLoader(true)
    const payload = {
      ...formData,
      agenct_config: { ...formData.agenct_config, plugins: changedPlugins.length > 0 ? changedPlugins : undefined },
      apps: {
        ...formData.apps,
        snapshotselected:
          formData.apps?.snapshotselected?.filter((item, index) => {
            return formData.apps.snapshotselected.indexOf(item) === index;
          }) || [],
      },
    };

    await updateSaasConfigration(payload, {
      onSuccess: ({ response }) => {
        if (response) {
          onClose();
          queryClient.invalidateQueries({ queryKey: ["saas"] });
        }
      }
    });
  };
  const handleToggleChange = async () => {
    setToggleChecked((prev) => !prev);
    setFormData((prevFormData) => ({
      ...prevFormData,
      agenct_config: {
        ...prevFormData.agenct_config,
        allow: !prevFormData.agenct_config.allow,
      },
    }));
  };

  const handleAgentLimitChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      agenct_config: {
        ...prevFormData.agenct_config,
        agent_limit: parseInt(e.target.value, 10) || 0,
      },
    }));
  };
  const handleToggleChange_add_credit = (event) => {
    setFormData({
      ...formData,
      trial_and_credit: { ...formData.trial_and_credit, add_credit: event.target.checked },
    });
  };
  const handleToggleChange_toggle_phone_system_reselling = (event) => {
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, ai_active: event.target.checked },
    });
  };

  const setselectedvalue = (val, id) => {
    const updatedSnapshotSelected = [...formData.apps.snapshotselected, val];
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });

    const element = document.getElementById(id);
    if (element) {
      element.classList.add("card_ofSelection_hover");
    }
  };
  const { data: categoryPricingResponse } = useCategoryPricing(agency._id);
  const currencies = (categoryPricingResponse?.data || []).map((item) => ({ label: item.name, value: item._id }));
  const promplabels = categoryPricingResponse?.promptslabel || [];
  // Replaces the old "refetch category pricing" local loader - kept the same
  // name since savecategory further below still calls onLoad().
  const onLoad = () => queryClient.invalidateQueries({ queryKey: ["saas-category-pricing"] });

  // ponytail: fetchAgents (AppService.assistant.Getassistant) was dead code -
  // defined but never called anywhere in this file, same as the
  // LoadPromptwithid dropped in an earlier migration pass noted above -
  // dropped rather than migrated, for the same reason.

  const handleIsFreeSaas = () => {
    setIsFreeSaas((prevState) => {
      const newValue = !prevState;
      setFormData({
        ...formData,
        isFreeSaas: newValue, // Use the updated value here
      });
      return newValue;
    });
  };
  const celenderappchanger = () => {
    setcelenderchanger(!celenderchanger);
    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!celenderchanger) {
      // If celenderchanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Celender App");
    } else {
      // If celenderchanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter(
        (item) => item !== "AI Celender App"
      );
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };
  const aiappchanger = () => {
    setaichanger(!aichanger);

    let updatedSnapshotSelected = [...formData.apps.snapshotselected];
    if (!aichanger) {
      // If aichanger is false, we are about to set it to true, so we push the value
      updatedSnapshotSelected.push("AI Social App");
    } else {
      // If aichanger is true, we are about to set it to false, so we remove the value
      updatedSnapshotSelected = updatedSnapshotSelected.filter((item) => item !== "AI Social App");
    }
    setFormData({
      ...formData,
      apps: { ...formData.apps, snapshotselected: updatedSnapshotSelected },
    });
  };
  const handleInputChange = (event) => {
    const tempSliderValue = event.target.value;
    if (tempSliderValue < 1) {
      return true;
    }
    setFormData({
      ...formData,
      rebilling: { ...formData.rebilling, markupmargin: tempSliderValue },
    });

    const progress = (tempSliderValue / event.target.max) * 100;
    event.target.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
  };
  const handleSelectChange_of_Category = (option) => {
    setFormData({
      ...formData,
      category: { ...formData.category, categoryOptions: option.value },
      category: { ...formData.category, categorySelected: option.value },
    });
  };

  const handleSelectChange_of_VAT = (option) => {
    setFormData({
      ...formData,
      vat: option.value,
    });
  };
  const handleSelectChange_of_promptlabels = (option) => {
    setFormData({
      ...formData,
      promptlabel_ids: option ? option.map((item) => item.value) : [],
    });
  };

  const handleSelectChange_of_agents = (option) => {
    setFormData({
      ...formData,
      selected_agents: option ? option.map((item) => item.value) : [],
    });
  };

  const handleSelectChange_of_stripe_products = (option) => {
    const selectedProducts = option ? option.map((item) => item.value) : [];
    setSelectedStripeProducts(option || []);
    setFormData({
      ...formData,
      selected_plan_for_product: selectedProducts,
    });
  };
  const [addCategoryModel, setAddCategoryModel] = useState(false);
  const [categoryFormData, setCategoryFormData] = useState([]);
  const availableCRNC = [
    { value: "usd", label: "$ USD" },
    { value: "eur", label: "€ Euro" },
    { value: "jpy", label: "¥ Japanese Yen" },
    { value: "gbp", label: "£ British Pound Sterling" },
    { value: "aud", label: "$ Australian Dollar" },
    { value: "cad", label: "$ Canadian Dollar" },
    { value: "chf", label: "Fr Swiss Franc" },
    { value: "cny", label: "¥ Chinese Yuan" },
    { value: "hkd", label: "HK$ Hong Kong Dollar" },
    { value: "nzd", label: "$ New Zealand Dollar" },
    { value: "sek", label: "kr Swedish Krona" },
    { value: "krw", label: "₩ South Korean Won" },
    { value: "sgd", label: "S$ Singapore Dollar" },
    { value: "nok", label: "kr Norwegian Krone" },
    { value: "mxn", label: "$ Mexican Peso" },
    { value: "inr", label: "₹ Indian Rupee" },
    { value: "rub", label: "₽ Russian Ruble" },
    { value: "zar", label: "R South African Rand" },
    { value: "brl", label: "R$ Brazilian Real" },
    { value: "try", label: "₺ Turkish Lira" },
    { value: "idr", label: "Rp Indonesian Rupiah" },
    { value: "thb", label: "฿ Thai Baht" },
    { value: "pln", label: "zł Polish Zloty" },
    { value: "php", label: "₱ Philippine Peso" },
    { value: "czk", label: "Kč Czech Koruna" },
    { value: "myr", label: "RM Malaysian Ringgit" },
    { value: "huf", label: "Ft Hungarian Forint" },
    { value: "isk", label: "kr Icelandic Króna" },
    { value: "hrk", label: "kn Croatian Kuna" },
    { value: "dkk", label: "kr Danish Krone" },
    { value: "ils", label: "₪ Israeli Shekel" },
    { value: "ars", label: "$ Argentine Peso" },
    { value: "clp", label: "$ Chilean Peso" },
    { value: "cop", label: "$ Colombian Peso" },
    { value: "pen", label: "S/. Peruvian Sol" },
    { value: "uah", label: "₴ Ukrainian Hryvnia" },
    { value: "egp", label: "£ Egyptian Pound" },
    { value: "sar", label: "ر.س Saudi Riyal" },
    { value: "aed", label: "د.إ UAE Dirham" },
    { value: "vnd", label: "₫ Vietnamese Dong" },
    { value: "kes", label: "KSh Kenyan Shilling" },
    { value: "ngn", label: "₦ Nigerian Naira" },
    { value: "pkr", label: "₨ Pakistani Rupee" },
    { value: "ghs", label: "₵ Ghanaian Cedi" },
    { value: "ugx", label: "USh Ugandan Shilling" },
    { value: "bdt", label: "৳ Bangladeshi Taka" },
    { value: "qar", label: "ر.ق Qatari Riyal" },
    { value: "lbp", label: "ل.ل Lebanese Pound" },
    { value: "mad", label: "د.م. Moroccan Dirham" },
    { value: "cup", label: "$ Cuban Peso" },
    { value: "crc", label: "₡ Costa Rican Colón" },
    { value: "npr", label: "₨ Nepalese Rupee" },
    { value: "hnl", label: "L Honduran Lempira" },
    { value: "gtq", label: "Q Guatemalan Quetzal" },
    { value: "pab", label: "B/. Panamanian Balboa" },
    { value: "uyu", label: "$U Uruguayan Peso" },
    { value: "bob", label: "Bs. Bolivian Boliviano" },
    { value: "pyg", label: "₲ Paraguayan Guarani" },
    { value: "etb", label: "ብር Ethiopian Birr" },
    { value: "awg", label: "ƒ Aruban Florin" },
    { value: "bsd", label: "$ Bahamian Dollar" },
    { value: "bbd", label: "$ Barbadian Dollar" },
    { value: "bzd", label: "BZ$ Belize Dollar" },
    { value: "bmd", label: "$ Bermudian Dollar" },
    { value: "kyd", label: "$ Cayman Islands Dollar" },
    { value: "fjd", label: "$ Fijian Dollar" },
    { value: "gyd", label: "$ Guyanese Dollar" },
    { value: "jmd", label: "J$ Jamaican Dollar" },
    { value: "lrd", label: "$ Liberian Dollar" },
    { value: "nad", label: "$ Namibian Dollar" },
    { value: "srd", label: "$ Surinamese Dollar" },
    { value: "ttd", label: "TT$ Trinidad and Tobago Dollar" },
    { value: "xcd", label: "$ East Caribbean Dollar" },
    { value: "sbd", label: "$ Solomon Islands Dollar" },
  ];

  const vatOptions = [
    { value: "no_vat", label: "No VAT" },
    { value: "vat_included", label: "VAT is included in the plan price" },
    { value: "vat_excluded", label: "VAT is excluded in the plan price" },
  ];

  const handlePluginsChange = (pluginId, currentStatus) => {
    setFormData((prevFormData) => {
      const updatedPlugins = prevFormData?.agenct_config?.plugins?.map((plugin) => {
        if (plugin.id === pluginId) {
          // Track the change
          setChangedPlugins((prev) => {
            // Remove if already present (toggle back)
            const filtered = prev.filter((p) => p.id !== pluginId);
            // If status is actually changed, add to changedPlugins
            if (plugin.is_active_for_plan === currentStatus) {
              return [...filtered, { id: pluginId, is_active_for_plan: !currentStatus }];
            }
            return filtered;
          });
          return { ...plugin, is_active_for_plan: !currentStatus };
        }
        return plugin;
      });
      return {
        ...prevFormData,
        agenct_config: {
          ...prevFormData.agenct_config,
          plugins: updatedPlugins,
        },
      };
    });
  };

  const Change_of_currency = (option) => {
    setCategoryFormData({
      ...categoryFormData,
      currency: option.value,
    });
  };
  const handleAddCategory = () => {
    setAddCategoryModel(true);
  };
  const { mutateAsync: createCategoryPricing } = useCreateCategoryPricing();
  const savecategory = async () => {
    categoryFormData.agency_id = agency._id;
    const payload = categoryFormData;
    const { response } = await createCategoryPricing(payload);
    if (response) {
      setAddCategoryModel(false);
      setCategoryFormData([]);
      onLoad();
    }
  };
  const formatString = (str) =>
    str
      .replace(/_/g, " ")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();
  return (
    <div className="container mt-4">
      <div className="flex justify-center">
        <div className="w-full lg:w-3/4">
          <div className="bg-white shadow-lg rounded-lg p-6">
            <div>
              <form>
                {step === 1 && (
                  <>
                    <div className="text-left mb-4">
                      <label htmlFor="planName" className="block mb-1 text-black">
                        Plan Name
                      </label>
                      <input
                        type="text"
                        id="planName"
                        className="form-control-agust w-full"
                        value={formData.plan.planName}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            plan: { ...formData.plan, planName: e.target.value },
                          })
                        }
                      />
                      {errors.planName && (
                        <small className="text-red-500" style={{ fontSize: "14px" }}>
                          {errors.planName}
                        </small>
                      )}
                    </div>
                    <div className="text-left mb-4">
                      <label htmlFor="description" className="block mb-1 text-black">
                        Description
                      </label>
                      <input
                        style={{ width: "100%", border: "1px solid #d8cbcb" }}
                        type="text"
                        id="description"
                        className="form-control-agust   w-full"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            plan: { ...formData.plan, description: e.target.value },
                          })
                        }
                        value={formData.plan.description}
                      />
                      {errors.description && (
                        <small className="text-red-500" style={{ fontSize: "14px" }}>
                          {errors.description}
                        </small>
                      )}
                    </div>

                    <div className="text-left mb-4">
                      <SoftTypography
                        className="text-black w-100 d-flex justify-content-between"
                        variant="button"
                        sx={{ fontSize: "14px", fontWeight: "500" }}
                        mt={1}
                      >
                        <label className="w-50 new_dezin_label text-black ">VAT</label>
                      </SoftTypography>

                      <ReactSelect
                        name="vat"
                        className="form-input w-full"
                        options={vatOptions}
                        isMultiple={false}
                        value={vatOptions.find((vat) => vat?.value === formData?.vat) || null}
                        onChange={handleSelectChange_of_VAT}
                      />
                    </div>

                    <div className="text-left mb-4">
                      <SoftTypography
                        className="text-black w-100 d-flex justify-content-between"
                        variant="button"
                        sx={{ fontSize: "14px", fontWeight: "500" }}
                        mt={1}
                      >
                        <label className="w-50 new_dezin_label text-black ">Category</label>
                        <p
                          className="w-50 text-right new_dezin_label text-black cursor-pointer"
                          onClick={handleAddCategory}
                        >
                          + Add Category
                        </p>
                      </SoftTypography>

                      <ReactSelect
                        name="category"
                        className="form-input w-full"
                        options={currencies}
                        isMultiple={false}
                        value={
                          currencies.find(
                            (currency) => currency?.value === formData?.category?.categorySelected
                          ) || null
                        }
                        onChange={handleSelectChange_of_Category}
                      />
                    </div>

                    <div
                      className="text-left mb-4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <input
                        type="checkbox"
                        name="isFreeSaas"
                        checked={isFreeSaas}
                        onChange={handleIsFreeSaas}
                        value={isFreeSaas}
                      />
                      <label
                        htmlFor="email"
                        className="block mb-1 text-black"
                        style={{ marginLeft: "14px" }}
                      >
                        Is it a Free SaaS plan?
                      </label>
                    </div>
                    {!isFreeSaas && (
                      <div className="d-flex justify-content-between">
                        <div className="text-left mb-4">
                          <label htmlFor="planName" className="block text-black">
                            Monthly Price
                          </label>
                          <input
                            type="number"
                            id="monthly_price"
                            name="monthly_price"
                            className="form-control-agust w-full"
                            value={formData?.monthly_price}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                monthly_price: e.target.value, // Directly update monthly_price
                              })
                            }
                          />
                        </div>

                        <div className="mb-4 text-left" style={{ margin: "0px 0px 0px 5px" }}>
                          <label htmlFor="planName" className="text-black">
                            Annual Price
                          </label>
                          <input
                            type="number"
                            id="yearly_price"
                            name="yearly_price"
                            className="form-control-agust w-full"
                            value={formData?.yearly_price}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                yearly_price: e.target.value, // Directly update yearly_price
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}

                {step === 2 && (
                  <>
                    <div className="mb-4">
                      <div className="mb-4">
                        <label htmlFor="planName" className="block mb-1 text-black">
                          User Limit
                        </label>
                        <FormField
                          type="number"
                          id="user_limit"
                          className="form-input w-full"
                          name="user_limit"
                          value={formData?.user_limit}
                          defaulValue={3}
                          onChange={(e) =>
                            setFormData({
                              ...formData,
                              user_limit: e.target.value,
                            })
                          }
                        />
                      </div>
                      <p className="font-15">
                        {" "}
                        Choose the features you want to enable for this plan{" "}
                      </p>

                      <div className="">
                        <div className="d-flex justify-between card_agust_row">
                          <div className="">
                            <p className="font-16 text-black">AI Social App</p>
                          </div>
                          <div className=" ">
                            <Switch checked={aichanger} onChange={aiappchanger} />
                          </div>
                        </div>
                        <div className="d-flex justify-between card_agust_row">
                          <div className="">
                            <p className="font-16 text-black">Content Calendar</p>
                          </div>
                          <div className=" ">
                            <Switch checked={celenderchanger} onChange={celenderappchanger} />
                          </div>
                        </div>

                        <div style={{ marginTop: "14px" }}>
                          <SoftTypography
                            className="text-black w-100 d-flex justify-content-between"
                            variant="button"
                            sx={{ fontSize: "14px", fontWeight: "500" }}
                            mb={1}
                          >
                            <label className="w-50 new_dezin_label text-black ">
                              Agent template names
                            </label>
                          </SoftTypography>
                          <ReactSelect
                            isMulti
                            name="promptlabel_ids"
                            className="form-input w-full"
                            options={
                              Array.isArray(promplabels)
                                ? promplabels
                                  .filter(
                                    (item) => item.api_type === "user" || item.api_type === "team"
                                  )
                                  .map((item) => ({
                                    label: item?.template?.templatename
                                      ? item?.template?.templatename
                                      : item?.name,
                                    value: item._id,
                                  }))
                                : []
                            }
                            value={
                              Array.isArray(promplabels)
                                ? promplabels
                                  .filter((item) => formData?.promptlabel_ids?.includes(item._id))
                                  .map((item) => ({
                                    label: item?.template?.templatename
                                      ? item?.template?.templatename
                                      : item?.name,
                                    value: item._id,
                                  }))
                                : []
                            }
                            onChange={handleSelectChange_of_promptlabels}
                          />
                        </div>

                        {/* <div style={{ marginTop: "14px" }}>
                          <SoftTypography
                            className="text-black w-100 d-flex justify-content-between"
                            variant="button"
                            sx={{ fontSize: "14px", fontWeight: "500" }}
                            mb={1}
                          >
                            <label className="w-50 new_dezin_label text-black ">
                              Select Agents
                            </label>
                          </SoftTypography>
                          <ReactSelect
                            isMulti
                            name="selected_agents"
                            className="form-input w-full"
                            options={agents}
                            value={agents.filter((agent) =>
                              formData?.selected_agents?.includes(agent.value)
                            )}
                            onChange={handleSelectChange_of_agents}
                            placeholder="Select agents..."
                          />
                        </div> */}

                        {/* <div>
                          <h2 className='text-black font-16'>Promp Labels</h2>
                          <ReactSelect
                            isMulti
                            name='promptlabel_ids'
                            className="form-input w-full"
                            options={promplabels}
                            onChange={handleSelectChange_of_promptlabels}
                          />
                        </div> */}
                      </div>
                    </div>
                  </>
                )}
                {step === 3 && (
                  <>
                    <div className="text-left mb-4">
                      <p className=" text-black font-15">
                        Enable the plugins and set the agent limit for this plan:
                      </p>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <span style={{ marginRight: "10px", fontSize: "22px !important" }}>
                          Enable plugin configurations
                        </span>
                        <Switch checked={toggleChecked} onChange={handleToggleChange} />
                      </div>
                      <hr />
                      {toggleChecked && (
                        <div className="">
                          {formData?.agenct_config?.plugins
                            ?.filter((plugin) => {
                              // Check if this plugin is active for agency
                              const isActiveForAgency = agency?.default_plugins?.some(
                                (agencyPlugin) =>
                                  agencyPlugin.id === plugin.id && agencyPlugin.is_active_for_agency
                              );
                              // Show if active for agency OR active for plan
                              return isActiveForAgency || plugin.is_active_for_plan;
                            })?.map((plugin) => (
                              <div key={plugin?.id} style={{ marginBottom: "20px" }}>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <label style={{ marginRight: "10px", fontSize: "16px" }}>
                                    {formatString(plugin.name).toUpperCase()}
                                  </label>
                                  <Switch
                                    checked={plugin.is_active_for_plan}
                                    onChange={() => handlePluginsChange(plugin?.id, plugin.is_active_for_plan)}
                                    name={plugin?.name}
                                  />
                                </div>
                              </div>
                            ))}
                          <div>
                            <SoftTypography
                              className="text-black w-100 d-flex justify-content-between"
                              variant="button"
                              sx={{ fontSize: "14px", fontWeight: "500" }}
                              mb={1}
                            >
                              <label className="w-100 new_dezin_label text-black ">
                                How many agents can account create?
                              </label>
                            </SoftTypography>
                            <input
                              type="number"
                              className="margin-top-10px form-control-agust"
                              min="1"
                              max="100"
                              style={{ width: "100%" }}
                              value={formData.agenct_config.agent_limit}
                              onChange={handleAgentLimitChange}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                )}
                {step === 4 && (
                  <>
                    <div className="text-left mb-4">
                      <div className="margin-top-10px">
                        <h2 className="text-black font-16">Trial period</h2>
                        <p className="font-15">
                          Enter the number of days for which a trial can be used.{" "}
                        </p>
                        <input
                          type="number"
                          className="margin-top-10px form-control-agust"
                          min="1"
                          max="100"
                          value={formData.trial_and_credit.days}
                          onChange={(e) => {
                            const newDaysValue = e.target.value;
                            setFormData({
                              ...formData,
                              trial_and_credit: {
                                ...formData.trial_and_credit,
                                days: newDaysValue,
                                active_trile_period: newDaysValue !== "0",
                              },
                            });
                            // setFormData({
                            //   ...formData,
                            //   trial_and_credit: { ...formData.trial_and_credit, days: e.target.value }
                            // })
                          }}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>
                    <div className="mb-4" style={{ marginTop: "10px" }}>
                      <div>
                        <h2 className="text-black font-16">Add Credit</h2>
                        <p className="font-15 ">
                          When a user signs up, you can offer them free credits to use email &
                          telephony services.
                        </p>

                        <input
                          type="number"
                          className="margin-top-10px form-control-agust"
                          min="1"
                          max="100"
                          value={formData.trial_and_credit.credit_amount}
                          onChange={(e) => {
                            const newCreditValue = e.target.value;
                            setFormData({
                              ...formData,
                              trial_and_credit: {
                                ...formData.trial_and_credit,
                                credit_amount: newCreditValue,
                                add_credit: newCreditValue !== "0",
                              },
                            });
                            // setFormData({
                            //   ...formData,
                            //   trial_and_credit: { ...formData.trial_and_credit, credit_amount: e.target.value },
                            // })
                          }}
                          style={{ width: "50%" }}
                        />
                      </div>
                    </div>

                    <div className="mb-4" style={{ marginTop: "10px" }}>
                      <h2 className="text-black font-16">Your AI tokens</h2>
                      <p className="font-15 ">
                        Enter the number of your AI monthly token for this plan a token is calculate
                        every time client enter button occurs which enables you to invoke a fair
                        usage policy.
                      </p>

                      <input
                        type="number"
                        style={{ marginTop: "10px" }}
                        id="daily_token_usage"
                        className="form-control-agust  w-full"
                        name="daily_token_usage"
                        value={formData.daily_token_usage}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            daily_token_usage: e.target.value,
                          })
                        }
                      />
                    </div>
                  </>
                )}
                {step === 5 && (
                  <>
                    <div className="d-flex justify-between card_agust_row">
                      <div className="">
                        <p className="font-16 text-black">AI Charges</p>
                      </div>
                      <div className=" ">
                        <Switch
                          checked={formData.rebilling.ai_active}
                          onChange={handleToggleChange_toggle_phone_system_reselling}
                        />
                      </div>
                    </div>
                    <div
                      className={`margin-top-10px ${formData.rebilling.ai_active ? "" : "diabled-div"
                        }`}
                    >
                      <h5 className="font-15 text-black">Markup Margin</h5>
                      <p className="font-15">
                        These are margins that are billed to your clients over the Phone System cost
                        borne by you
                        <br></br>
                        <input
                          type="range"
                          min="0"
                          max="100"
                          onChange={handleInputChange}
                          id="range2"
                          className="range-input"
                          value={formData.rebilling.markupmargin}
                        />
                        {formData.rebilling.markupmargin} Times
                      </p>
                      <div className="heightmanagmable">
                        <div className="d-flex">
                          <div style={{ margin: "0px 20px 0px 0px", width: '32%' }}>
                            <label className="text-black">API Cost Price</label>
                            <div className="form-control-agust-gray font-16">
                              {agency?.charge_per_api || 0.01}/API
                            </div>
                          </div>
                          <div style={{ margin: "0px 20px 0px 0px", width: '32%' }}>
                            <label>API Selling Price</label>
                            <div className="form-control-agust-gray font-16">
                              {`${agency?.charge_per_api || 0.01} x ${formData.rebilling.markupmargin} = ${Math.abs(
                                (agency?.charge_per_api || 0.01) * formData.rebilling.markupmargin
                              ).toFixed(3)}`}
                            </div>
                          </div>
                          <div style={{ margin: "0px 20px 0px 0px", width: '32%' }}>
                            <label>Profit</label>
                            <div className="form-control-agust-success font-16">
                              {`${parseFloat(
                                (
                                  (agency?.charge_per_api || 0.01) * formData.rebilling.markupmargin -
                                  (agency?.charge_per_api || 0.01)
                                ).toFixed(3)
                              )}`}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {step === 6 && (
                  <>
                    <div className="text-left mb-4 margin-top-10px">
                      <div className="d-flex justify-between " style={{ alignItems: "center" }}>
                        <div className="">
                          <p
                            className="font-16 text-black font-bold"
                            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                          >
                            <svg
                              width="29"
                              height="29"
                              viewBox="0 0 200 200"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="black"
                            >
                              {/* Top circle with 1 */}
                              <circle
                                cx="70"
                                cy="70"
                                r="30"
                                stroke="black"
                                strokeWidth="10"
                                fill="none"
                              />
                              <rect
                                x="65"
                                y="55"
                                width="10"
                                height="30"
                                rx="5"
                                ry="5"
                                fill="black"
                              />

                              {/* Bottom rotated semi-circle with slash */}
                              <path
                                d="M130 100 a30 30 0 1 1 -21 8"
                                stroke="black"
                                strokeWidth="10"
                                fill="none"
                              />
                              <rect
                                x="115"
                                y="105"
                                width="10"
                                height="30"
                                rx="5"
                                ry="5"
                                fill="black"
                                transform="rotate(45 120 120)"
                              />
                            </svg>
                            <span>Create AI Agents</span>
                          </p>
                          <span style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                            Can this plan create AI Agent
                          </span>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.create_agents}
                            onChange={(e) =>
                              setFormData({ ...formData, create_agents: e.target.checked })
                            }
                          />
                        </div>
                      </div>

                      {formData?.create_agents && (
                        <div
                          className="d-flex justify-between margin-top-10px"
                          style={{ alignItems: "center" }}
                        >
                          <div className="">
                            <p
                              className="font-16 text-black font-bold"
                              style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
                            >
                              <span>Unlimited</span>
                            </p>
                            <span style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                              This plan can create unlimited AI Agents
                            </span>
                          </div>
                          <div className=" ">
                            <Switch
                              checked={formData.number_of_agents === "infinite"}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  number_of_agents: e.target.checked ? "infinite" : "0",
                                })
                              }
                            />
                          </div>
                        </div>
                      )}

                      {formData?.number_of_agents === "0" && (
                        <div className={`margin-top-10px`}>
                          <p
                            style={{
                              fontSize: "16px",
                              fontWeight: "bold",
                              marginLeft: "8px",
                              marginTop: "14px",
                            }}
                          >
                            Number of AI Agents
                          </p>
                          <p style={{ color: "#757575", fontSize: "14px", marginLeft: "8px" }}>
                            How many AI Agent can this plan create?
                          </p>
                          <input
                            style={{
                              marginLeft: "8px",
                              marginBlock: "14px",
                              width: "95%",
                              borderRadius: "4px",
                              padding: "10px",
                              fontSize: "14px",
                            }}
                            type="number"
                            value={parseInt(formData.number_of_agents)}
                            onChange={(e) =>
                              setFormData({ ...formData, number_of_agents: e.target.value })
                            }
                            min={0}
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {step === 7 && (
                  <>
                    <div className="text-left mb-4">
                      <div className="d-flex justify-between card_agust_row">
                        <div className="">
                          <p className="font-16 text-black">Create additional accounts</p>
                          <p className="font-15">Can this plan create additional accounts?</p>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.additional_accounts_enabled || false}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                additional_accounts_enabled: e.target.checked,
                              })
                            }
                          />
                        </div>
                      </div>

                      {formData.additional_accounts_enabled && (
                        <div className="text-left mb-4 mt-4">
                          <label htmlFor="additional_accounts" className="block text-black mb-2">
                            Number of additional accounts
                          </label>
                          <p className="font-15 mb-2">
                            How many additional accounts can this plan create
                          </p>
                          <input
                            type="number"
                            id="additional_accounts"
                            className="form-control-agust w-full"
                            name="additional_accounts"
                            value={formData.additional_accounts}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                additional_accounts: e.target.value,
                              })
                            }
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                {step === 8 && (
                  <>
                    <div className="text-left mb-4">
                      <h2 className="text-black font-18 mb-3">Add Plan to existing Stripe product</h2>
                      <div className="d-flex justify-between card_agust_row" style={{ alignItems: "center" }}>
                        <div className="">
                          <p className="font-16 text-black">Add this plan to an existing Stripe product</p>
                          <p className="font-15">Connect this plan to other Stripe products</p>
                        </div>
                        <div className=" ">
                          <Switch
                            checked={formData.add_plan_to_product || false}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                add_plan_to_product: e.target.checked,
                              })
                            }
                          />
                        </div>
                      </div>

                      {formData.add_plan_to_product && (
                        <div className="text-left mb-4 mt-4">
                          <label htmlFor="stripe_products" className="block text-black mb-2">
                            Select products
                          </label>
                          <ReactSelect
                            isMulti
                            name="stripe_products"
                            className="form-input w-full"
                            options={stripeProducts}
                            value={selectedStripeProducts}
                            onChange={handleSelectChange_of_stripe_products}
                            placeholder="Select Stripe products..."
                          />
                        </div>
                      )}
                    </div>
                  </>
                )}

                <div className="d-flex mt-6" style={{ justifyContent: "space-between" }}>
                  <button
                    className="savebtn-setting "
                    style={{ marginTop: "10px", width: "40%" }}
                    type="button"
                    onClick={() => handleCustomTab()}
                  >
                    Back
                  </button>

                  {step < 8 && (
                    <button
                      className="savebtn-setting"
                      style={{ marginTop: "10px", width: "40%" }}
                      type="button"
                      onClick={handleNext}
                    >
                      Next
                    </button>
                  )}
                  {step === 8 && (
                    <button
                      className="savebtn-setting "
                      style={{ marginTop: "10px", width: "40%" }}
                      onClick={handleFormSubmit}
                      disabled={loader}
                    >
                      {loader ? "Wait..." : "Submit"}
                    </button>
                  )}
                </div>
              </form>
            </div>
            <div
              className="d-flex  justify-content-between"
              style={{ width: "100%", margin: "15px 20%", marginLeft: "15px" }}
            >
              <span className={step === 1 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={1 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 2 ? "color-active-new" : "color-inactive-new"}></span>

              <div
                className={2 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 3 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={3 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 4 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={4 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 5 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={5 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 6 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={6 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 7 ? "color-active-new" : "color-inactive-new"}></span>
              <div
                className={7 < step ? "color-active-border-new" : "color-inactive-border-new"}
                style={{ width: "20%" }}
              ></div>
              <span className={step === 8 ? "color-active-new" : "color-inactive-new"}></span>
            </div>

            {addCategoryModel && (
              <div className="modal-zz-confirm text-left">
                <div
                  className="scrollable-modal-content bg-white rounded"
                  style={{ position: "relative" }}
                >
                  <h2 className="text-black text-left font-14" style={{ marginBottom: "10px" }}>
                    Add New Category
                  </h2>
                  <span className="crossison" onClick={() => setAddCategoryModel(false)}>
                    X
                  </span>
                  <input
                    type="text"
                    id="category"
                    className="form-control-agust w-full"
                    name="category"
                    placeholder={"Enter Category Name "}
                    value={categoryFormData.category}
                    onChange={(e) =>
                      setCategoryFormData({
                        ...categoryFormData,
                        name: e.target.value,
                      })
                    }
                  />
                  <div style={{ margin: "10px 0px" }}>
                    <ReactSelect
                      className="form-input w-full"
                      options={availableCRNC}
                      isMulti={false}
                      onChange={Change_of_currency}
                      menuPortalTarget={document.body} // Render dropdown outside the modal
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }), // Set z-index for visibility
                      }}
                    />
                  </div>
                  <div className="w-100 margin-top-20px">
                    <button type="submit" className="btn-newdezine" onClick={savecategory}>
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfigrationForm;
